<template>
  <div class="fixWidth container-fluid">
    <v-dialog v-model="formDialogStatus" max-width="1000px" persistent>
      <formDialog
        :dialogStatus.sync="formDialogStatus"
        :editedData="editedItem"
        :indexEdited.sync="editedIndex"
        @callReget="
          (val) => {
            if (val) {
              this.pagination.page = 1;
            }
            this.searchInstitute();
          }
        "
      ></formDialog>
    </v-dialog>
    <v-dialog v-model="deleteDialogStatus" max-width="600px">
      <deleteDialog
        v-on:changeTitle="updateTitleData($event)"
        v-on:changeStat="closeDelDialog($event)"
      ></deleteDialog>
    </v-dialog>
    <snackbar :snacksProp="snackBar" />
    <template>
      <v-expansion-panels focusable>
        <v-expansion-panel class="mb-3">
          <v-expansion-panel-header
            >Custom Search Panel</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-container class="fixWidth">
              <!-- {{getDivisionItem}} -->
              <v-row ref="formVal">
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    name="Title"
                    item-text="en_name"
                    item-value="division_code"
                    v-model="searchParam.division_code"
                    chips
                    :items="getDivisionItem"
                    label="Division Name"
                    :key="searchParam.division_code"
                    @change="searchDistrictByDivision()"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="grey lighten-4"
                        :input-value="data.selected"
                      >
                        <span class="subheading">{{ data.item.en_name }}</span>
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    name="Title"
                    item-text="en_name"
                    item-value="district_code"
                    v-model="searchParam.district_code"
                    chips
                    :items="getDistrictItem"
                    label="District"
                    :key="searchParam.district_code"
                    @change="searchThanaByDistrict()"
                    :disabled="
                      searchParam.division_code == undefined ? true : false
                    "
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="grey lighten-4"
                        :input-value="data.selected"
                      >
                        <span class="subheading">{{ data.item.en_name }}</span>
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    name="Title"
                    item-text="en_name"
                    item-value="thana_code"
                    v-model="searchParam.thana_code"
                    chips
                    :items="getThanaItem"
                    label="Thana"
                    :key="searchParam.thana_code"
                    @change="searchPostOfficeByThana()"
                    :disabled="
                      searchParam.district_code == undefined ? true : false
                    "
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="grey lighten-4"
                        :input-value="data.selected"
                      >
                        <span class="subheading">{{ data.item.en_name }}</span>
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    name="Title"
                    item-text="en_name"
                    item-value="post_office_code"
                    v-model="searchParam.post_code"
                    chips
                    :items="getPostOfficeItem"
                    label="Post Office"
                    :key="searchParam.post_code"
                    :disabled="
                      searchParam.thana_code == undefined ? true : false
                    "
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        color="grey lighten-4"
                        :input-value="data.selected"
                      >
                        <span class="subheading">{{ data.item.en_name }}</span>
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col> -->
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Institute Name"
                    v-model="searchParam.institute_name_en"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Institute Eiin No"
                    v-model="searchParam.eiin_no"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-layout justify-center>
                <div>
                  <v-btn
                    color="red"
                    style="margin-left"
                    @click.stop.prevent="clear()"
                    >Clear</v-btn
                  >
                </div>
                <div style="width: 20px"></div>
                <div>
                  <v-btn
                    color="primary  white--text"
                    @click.stop.prevent="searchInstitute()"
                    >Search</v-btn
                  >
                </div>
                <span></span>
              </v-layout>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <!-- {{authRolePermissionData.role_permission}} -->
    <!-- {{permissionForInstituteAction.list}} -->
    <v-data-table
      :headers="headers"
      :items="getInstituteItem"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :footer-props="pagination.rowsPerPageItems"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Institute List</v-toolbar-title>
          <!-- {{getErrorMessage.message}} -->
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="newItem"
            v-if="functionalAccess.add == '1'"
            >Create New Institute
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.id="{ item, index }">
        {{ index + (pagination.page - 1) * pagination.itemsPerPage + 1 }}
      </template>
      <template v-slot:item.logo="{ item }">
        <v-img
          v-if="item.logo != undefined || item.logo != null"
          :src="`${baseURL}/${item.logo}`"
          max-height="30"
          max-width="30"
          style="cursor: pointer"
          contain
          @click="goLarge(item.logo)"
        ></v-img>
      </template>

      <template v-slot:item.website_url="{ item }">
        <a href="#" @click="redirector(item.website_url)">
          <!-- <v-icon>mdi-web</v-icon> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="25px"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                color="primary"
              >
                mdi-web
              </v-icon>
            </template>
            <span> Url </span>
          </v-tooltip>
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="25px"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              color="primary"
              v-if="functionalAccess.edit == '1'"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span> Edit </span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="25px"
              class="mr-2"
              color="red"
              v-bind="attrs"
              v-on="on"
              v-if="functionalAccess.delete == '1'"
              @click="deleteDialogOpen(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <div>No Data Found</div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import formDialog from "@/components/institute/instituteFormNew.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import snackbar from "@/components/utils/snackbar.vue";
import searchDistrictByDivision from "@/mixins/searchDistrictByDivision";
import searchThanaByDistrict from "@/mixins/searchThanaByDistrict";
import searchPostOfficeByThana from "@/mixins/searchPostOfficeByThana";
import functionalMixin from "../../mixins/searchFunction";
import { baseURL2 } from "../../store/api";
import clearSearch from "@/mixins/clearSearch";

export default {
  components: {
    formDialog,
    deleteDialog,
    snackbar,
  },
  data() {
    return {
      pagination: {
        itemsPerPage: 10,
        rowsPerPageItems: { "items-per-page-options": [5, 10, 25, 100, 200] },
      },
      // authRolePermissionData:[],
      snackbarMessage: "",
      totalItems: null,
      searchString: "",
      editedItem: {},
      editedIndex: -1,
      loading: false,
      title: "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus: false,
      deleteId: {},
      currentItem: {},
      divisionList: [],
      searchString: "",
      searchParam: {},
      pathIndexFound: "",
      // permissionForInstituteAction:{},
      snackBar: {
        control: false,

        multiline: true,
        text: {
          message: "",
        },
      },

      headers: [
        { text: "Serial No.", value: "id", sortable: false },
        { text: "Logo", value: "logo", sortable: false },
        {
          text: "Institute Name in English",
          value: "institute_name_en",
          sortable: false,
        },
        { text: "Division Name", value: "division_en_name", sortable: false },
        { text: "District Name", value: "district_en_name", sortable: false },
        { text: "Thana Name", value: "thana_en_name", sortable: false },
        {
          text: "Post Office Name",
          value: "post_office_en_name",
          sortable: false,
        },
        { text: "Eiin No", value: "eiin_no", sortable: false },
        { text: "Address", value: "address", sortable: false },
        { text: "Url", value: "website_url", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  async created() {
    await this.$store.dispatch("callDivisonData", {
      page: 1,
      size: -1,
    });
    //  await this.$store.dispatch("callDistrictData", {
    //   page: 1,
    //   size: -1
    // });
    //  await this.$store.dispatch("callThanaData", {
    //   page: 1,
    //   size: -1
    // });
    // await this.$store.dispatch("callPostOfficeData", {
    //   page: 1,
    //   size: -1
    // });
    // this.authRolePermissionData = JSON.parse(
    //   window.localStorage.getItem("authRolePermissionData")
    // );
    ////  console.log("this.authRolePermissionData",this.authRolePermissionData);
    // this.searchPath();
  },
  mounted() {},
  computed: {
    getDivisionItem() {
      return this.$store.getters.getDivisionItem;
    },
    getDistrictItem() {
      return this.$store.getters.getDistrictItem;
    },
    getThanaItem() {
      return this.$store.getters.getThanaItem;
    },
    getPostOfficeItem() {
      return this.$store.getters.getPostOfficeItem;
    },
    getInstituteItem() {
      return this.$store.getters.getInstituteItem;
    },
    getLoggedInStatus() {
      return this.$store.getters.getLoggedIn;
    },
    getTitle() {
      return this.title;
    },
    getResponseMessage() {
      return this.$store.getters.getResponseMessage;
    },
    getErrorMessage(state) {
      return this.$store.getters.getErrorMessage;
    },
    baseURL() {
      return baseURL2;
    },
  },
  watch: {
    // permissionForInstituteAction(val){
    //    //  console.log("val",val);
    //     this.searchInstitute();
    // },
    getTitle(val) {
      if (val == "confirmed") {
        this.deleteItem();
      }
    },
    pagination() {
      this.searchInstitute();
    },
    getResponseMessage(val) {
      this.snackBar.text.message = val.message;
      this.snackBar.control = true;
    },
    getErrorMessage(val) {
      let myObject = val.message;
      for (const [key, value] of Object.entries(myObject)) {
        this.snackBar.text.message = value[0];
        this.snackBar.control = true;
      }
    },
  },
  mixins: [
    searchDistrictByDivision,
    searchThanaByDistrict,
    searchPostOfficeByThana,
    functionalMixin,
    clearSearch,
  ],
  methods: {
    searchInstitute() {
      //   //  console.log("asaasas",this.permissionForInstituteAction.list);
      //  if(this.permissionForInstituteAction.list == '1'){
      this.loading = true;

      this.searchString = "";
      if (this.searchParam.division_code) {
        this.searchString = `division_code=${this.searchParam.division_code}`;
      }
      if (this.searchParam.district_code) {
        if (this.searchString == "") {
          this.searchString = `district_code=${this.searchParam.district_code}`;
        } else {
          this.searchString = `${this.searchString} and district_code=${this.searchParam.district_code}`;
        }
      }
      if (this.searchParam.thana_code) {
        if (this.searchString == "") {
          this.searchString = `thana_code=${this.searchParam.thana_code}`;
        } else {
          this.searchString = `${this.searchString} and thana_code=${this.searchParam.thana_code}`;
        }
      }
      if (this.searchParam.post_office_code) {
        if (this.searchString == "") {
          this.searchString = `post_code=${this.searchParam.post_office_code}`;
        } else {
          this.searchString = `${this.searchString} and post_code=${this.searchParam.post_office_code}`;
        }
      }
      if (this.searchParam.institute_name_en) {
        if (this.searchString == "") {
          this.searchString = `institute_name_en like '%${this.searchParam.institute_name_en}%'`;
        } else {
          this.searchString = `${this.searchString} and institute_name_en like '%${this.searchParam.institute_name_en}%'`;
        }
      }
      if (this.searchParam.eiin_no) {
        if (this.searchString == "") {
          this.searchString = `eiin_no=${this.searchParam.eiin_no}`;
        } else {
          this.searchString = `${this.searchString} and eiin_no=${this.searchParam.eiin_no}`;
        }
      }
      encodeURIComponent(this.searchString);
      this.$store
        .dispatch("callInstitueData", {
          page: this.pagination.page,
          size: this.pagination.itemsPerPage,
          search: this.searchString,
        })
        .then((data) => {
          this.loading = false;
          this.totalItems = this.$store.getters.getDataCount;
        });

      // }
    },
    redirector(url) {
      if (url.startsWith("http")) {
        window.open(url);
      } else {
        window.open(`http://${url}`);
      }
      return false;
    },
    dialogOpen() {
      this.formDialogStatus = true;
    },
    closeDelDialog(deleteDialogStatus) {
      this.deleteDialogStatus = false;
    },
    updateTitleData(title) {
      this.title = title;
    },
    newItem() {
      this.dialogOpen();
    },
    editItem(item) {
      this.editedIndex = this.getInstituteItem.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("SET_INSTITUTE_SCHEMA", this.editedItem);
      //  console.log("this.editedItem.division_code",this.editedItem.division_code);
      if (this.editedItem.division_code) {
        let tempString = `division_code=${this.editedItem.division_code}`;
        this.$store.dispatch("callDistrictData", {
          page: 1,
          size: -1,
          search: tempString,
        });
      }
      if (this.editedItem.district_code) {
        let tempString = `district_code=${this.editedItem.district_code}`;
        this.$store.dispatch("callThanaData", {
          page: 1,
          size: -1,
          search: tempString,
        });
      }

      this.dialogOpen();
    },
    deleteDialogOpen(item) {
      this.deleteId = item.id;
      this.deleteDialogStatus = true;
    },
    deleteItem() {
      let self = this;
      this.$store
        .dispatch("deleteInstitueItem", this.deleteId)
        .then(function (data) {
          try {
            self.title = "";
            self.deleteDialogStatus = false;
            self.searchInstitute();
          } catch (ex) {
            //  console.log(ex);
          }
        })
        .catch(function (error) {
          //  console.log(error);
        });
    },

    // searchPath(){
    //   var authPermissionData = this.authRolePermissionData.role_permission;
    //   authPermissionData.forEach((obj) => {
    //     var pathIndex = -1;
    //     for(var i=0; i<obj.child.length; i++) {

    //       if(obj.child[i].path == '/admin/institute-new') {
    //           // __FOUND is set to the index of the element
    //           pathIndex = i;
    //           break;
    //         }
    //       }
    //       if(pathIndex != -1){
    //         ////  console.log("pathIndex pathIndex pathIndex",pathIndex);
    //         this.pathIndexFound = pathIndex;

    //         this.permissionForInstituteAction = obj.child[this.pathIndexFound];
    //       }

    //     });
    // },

    goLarge(url) {
      window.open(`${this.baseURL}/${url}`);
      return false;
    },
  },
};
</script>
<style>
.v-data-table th {
  font-size: 14px !important;
}
.fixWidth {
  width: auto;
}
</style>
